import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

const AuthSlider = () => {

    const slides = [
        {
          title: ()=><>Welcome to <br /> 
            <img src="/assets/images/certificate/certificate_logo.png" style={{ marginTop:'-10px'}} width={180} height={40}/>
           {/* <span style={{ color: "#260efcff" }}>Hunarho {" "}</span> */}
           <span style={{ color: "#2D3748" }}>Platform</span>.
          </>,
          description:
            "A complete learning platform that connects students, instructors, institutes, and TPOs — making education, management, and growth simple and effective.",
          illustration: "login",
          image:'/auth/onboarding-1.svg'
        },
        {
          title: ()=><><span style={{ color: "#260efcff" }}>Learn, Teach & Manage{" "}</span><br/> Seamlessly</>,
          description:
            "Access courses, training materials, and management tools anytime, anywhere — whether you’re here to learn, teach, guide, or organize.",
          illustration: "learning",
          image:'/auth/onboarding-2.svg'
        },
        {
          title: ()=><>Track <span style={{ color: "#260efcff" }}>Progress & Career<br /> Growth{" "}</span></>,
          description: "Get real-time insights into learning performance, skill development, and placement updates — from course progress to job applications and hiring outcomes.",
          illustration: "progress",
          image:'/auth/onboarding-3.svg'
        },
        {
          title: ()=><>Stay <span style={{ color: "#260efcff" }}>Organized {" "}</span>Effortlessly</>,
          description: "Keep everything in one place — manage skills, job postings, or student records with the platform that save time and simplify daily tasks.",
          illustration: "progress",
          image:'/auth/onboarding-4.svg'
        },
        {
          title: ()=><>Empower <span style={{ color: "#260efcff" }}>Learning & <br />Opportunities {" "}</span></>,
          description: "Grow your knowledge, connect with the right people, and unlock new academic and career opportunities — all within Hunarho LMS.",
          illustration: "progress",
          image:'/auth/onboarding-5.svg'
        },
    ]

    return (
        <div className="col-lg-6 d-none d-lg-flex position-fixed top-0 start-0" style={{ background: "#e8f0fe", height: "100vh", overflow: "hidden" }}>
            <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 10000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                loop={true}
                breakpoints={{
                    320: { slidesPerView: 1, spaceBetween: 10 },
                    768: { slidesPerView: 1, spaceBetween: 20 },
                    1200: { slidesPerView: 1, spaceBetween: 30 },
                }}
                className="w-100 h-100"
            >
                {slides?.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="d-flex align-items-center justify-content-center h-100">
                            <div className="text-center">
                                <div className="mb-4 position-relative">
                                    <img
                                        src={slide.image}
                                        className="img-fluid"
                                        width={400}
                                        height={300}
                                        alt={slide.illustration}
                                    />
                                </div>

                                <h2
                                    className="fw-bold mb-3 text-balance"
                                    style={{ fontSize: "2.5rem", color: "#2D3748", lineHeight: "1.2" }}
                                >
                                    {slide.title()}
                                </h2>
                                <p
                                    className="mb-4 text-pretty"
                                    style={{
                                        fontSize: "1rem",
                                        lineHeight: "1.6",
                                        fontWeight: "400",
                                        maxWidth: "558px",
                                        margin: "auto",
                                    }}
                                >
                                    {slide.description}
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default AuthSlider